// extracted by mini-css-extract-plugin
export default {"content":"LoyaltyPromoModal_content__fnZei","button":"LoyaltyPromoModal_button__LF8EI"};